<div>
	<lib-card [isForm]="true" [title]="'Your brand'">
		<ui-text-form-field
			[title]="'Name'"
			[isRequired]="true"
			[valueAsSignal]="form.brandName"
			[maxLength]="brandNameMaxLength"
		></ui-text-form-field>

		<ui-text-form-field
			class="push-top-md"
			[title]="'Tel'"
			[subtitle]="'Clients will see your phone number'"
			[isRequired]="false"
			[valueAsSignal]="form.brandTel"
			[maxLength]="20"
		></ui-text-form-field>

		<ui-text-area-form-field
			class="push-top-md"
			[title]="'Bio'"
			[valueAsSignal]="form.brandBio"
			[enableEmoji]="true"
			[maxLength]="2000"
		></ui-text-area-form-field>
	</lib-card>

	<lib-card [isForm]="true" [title]="'Branded domain'" class="push-top-md" [subtitle]="subdomainSubtitle">
		<ui-text-form-field
			[title]="'Subdomain'"
			[isRequired]="true"
			[valueAsSignal]="form.brandingSubdomain"
			[maxLength]="subdomainMaxLength"
			[suffix]="subdomainSuffix()"
		></ui-text-form-field>

		@if (customSubdomainAbsoluteUrl(); as customSubdomainAbsoluteUrl) {
		<div class="push-top">
			<lib-message [type]="'tip'" [title]="'Your branded URL'">
				<lib-link
					[linkStyle]="'default'"
					[displayStyle]="'inline'"
					[routerLink]="undefined"
					[externalUrl]="customSubdomainAbsoluteUrl"
					>{{ customSubdomainAbsoluteUrl }}</lib-link
				>
			</lib-message>
		</div>
		}
	</lib-card>

	<lib-card [isForm]="true" [title]="'Logo'" class="push-top-md">
		<ui-file-form-field
			[validation]="'images'"
			[isRequired]="false"
			[maxFiles]="1"
			[imageCrop]="imageCrop"
			[uploadFunction]="uploadFunction"
			[valueAsSignal]="form.brandLogo"
			(valueChange)="handleBrandLogoChange($event)"
		></ui-file-form-field>
	</lib-card>

	<ui-form-save-button
		class="push-top-md"
		[title]="'Save'"
		[saveHandler]="saveHandler()"
		[logHandler]="formLogHandler()"
	></ui-form-save-button>
</div>
